<div class="empty-panel"></div>

<div class="side-panel">
    <div class="row">
        <div class="col-12 title">{{ "Roster.PageTitle" | translate }}</div>
        <div class="col-12 sub-title">
            {{ "Roster.PageTitleHint" | translate }}
        </div>
    </div>

    <form
        [formGroup]="searchForm"
        novalidate
        class="voffset-20"
        (ngSubmit)="onSubmit()"
    >
        <div class="form-group form-horizontal">
            <div class="form-group form-horizontal voffset20">
                <label class="panel-label">{{
                    "Roster.Club" | translate
                }}</label>
                <select formControlName="clubId" class="form-control" hznTestId="roster-club">
                    @for (club of clubs; track club) {
                        <option [ngValue]="club.id">{{ club.name }}</option>
                    }
                </select>
            </div>

            <hr />

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "Roster.DateFrom" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            formControlName="dateFrom"
                            hznTestId="roster-date-from"
                            name="dateFrom"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "Roster.DateTo" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            formControlName="dateTo"
                            hznTestId="roster-date-to"
                            name="dateTo"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>

            <div class="row d-flex align-items-end">
                <div class="col">
                    <button
                        class="btn btn-primary pull-right"
                        type="submit"
                        hznTestId="roster-search"
                        [disabled]="!isFormValid()"
                    >
                        {{ "Roster.search" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
